import { useCallback } from 'react';

interface ValidationError {
    path: string;
    type?: string;
    message: string;
}

interface YupError {
    inner: ValidationError[];
}

export const useYupValidationResolver = (validationSchema: any, context = {}) => useCallback(
    async (data: any) => {
        try {
            const values = await validationSchema.validate(data, {
                abortEarly: false,
                context,
            });

            return {
                values,
                errors: {},
            };
        } catch (errors: any) {
            return {
                values: {},
                errors: (errors as YupError)?.inner?.reduce(
                    (allErrors, currentError) => ({
                        ...allErrors,
                        [currentError.path]: {
                            type: currentError.type || 'validation',
                            message: currentError.message,
                        },
                    }),
                    {},
                ) || {},
            };
        }
    },
    [validationSchema, context],
);
